import { FC } from 'react';
import { formatPrice } from '@nextgen-web-framework/core';
import { useTranslation } from '@nextgen-web-framework/all';
import { PriceComponentPropsTypes } from './types/propsTypes';
import styles from './PriceComponent.module.scss';
import { PriceType } from './types/enums';

const PriceComponent: FC<PriceComponentPropsTypes> = ({
  productPrice,
  currency,
  strikethroughPrice,
  priceType,
  showZeroAsFree = true,
  isRetailPrice = false,
  prefixText = '',
}: PriceComponentPropsTypes): JSX.Element => {
  const t = useTranslation();
  const PriceClassName = () => {
    switch (priceType) {
      case PriceType.PRICEABOCHECKBOXCARD:
        return 'product-price-abo-checkbox';
      case PriceType.PRICESEARCHRESULTCARD:
        return 'product-price-search-result-card';
      case PriceType.PRICE_PDP:
        return 'product-price-pdp';
      case PriceType.PRICE_PLP_SEARCH_CARD:
        return 'product-price-plp-search-card';
      case PriceType.PRICE_GCO_CARD:
        return 'product-price-gco-card';
      case PriceType.PRICE_VARIANT_CARD:
        return 'product-price-variant-card';
      case PriceType.CART_CARD_VARIANT:
        return 'product-price-cart-card';
      case PriceType.CART_CARD_MOBILE_VARIANT:
        return 'product-price-cart-card-mobile-view-force';
      case PriceType.CHECKOUT:
        return 'product-price-checkout-card';
      case PriceType.FREE_PRODUCT_CARD:
        return 'product-price-free-product-card';
      case PriceType.PRODUCT_MERCHANDISE:
        return 'product-price-product-merchandise-view';
      case PriceType.PROMOTION_CARD:
        return 'product-price-product-promotion-card';
      case PriceType.PRICE_RANGE:
        return 'product-price-price-range';
      case PriceType.PRICE_POST_PURCHASE:
        return 'product-price-post-purchase';
      default:
        return 'product-price';
    }
  };
  return (
    <>
      {productPrice !== undefined && (
        <span className={`${styles[PriceClassName()]} ${isRetailPrice && styles['retail-price']}`}>
          {showZeroAsFree && !isRetailPrice && productPrice === 0 ? (
            <span className={styles['free-product']} data-testid="free-product-test-id">
              {t('product.priceComponent.free')}
            </span>
          ) : (
            productPrice >= 0 && (
              <p className={`${styles['price-value']}`} data-testid="price-value-test-id">
                {isRetailPrice && prefixText}
                {formatPrice(productPrice, currency)}
              </p>
            )
          )}
          {!!strikethroughPrice && strikethroughPrice > 0 && strikethroughPrice > productPrice && (
            <span className={styles['strike-through']}>{formatPrice(strikethroughPrice, currency)}</span>
          )}
        </span>
      )}
    </>
  );
};

export default PriceComponent;
export type { PriceComponentPropsTypes };
export { PriceType };
